import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    console.log("pathname:", pathname, "hash:", hash);

    if (!hash) {

      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      return;
    }

    const id = hash.slice(1);

    let tries = 0;
    const maxTries = 20; // ~1s total
    const interval = setInterval(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "start" });
        clearInterval(interval);
      } else {
        tries += 1;
        if (tries >= maxTries) clearInterval(interval);
      }
    }, 50);

    return () => clearInterval(interval);
  }, [pathname, hash]);

  return null;
}
